var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEsLightUp4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4853 26L19.364 35.1213C18.7474 35.7379 17.9292 36.03 17.1217 35.9976C17.0813 35.9992 17.0407 36 17 36H13C11.3431 36 10 34.6569 10 33C10 31.3431 11.3431 30 13 30H16L25.0662 20.9338C25.3233 20.6767 25.6154 20.4761 25.9272 20.3318C26.3386 20.1197 26.8053 20 27.3 20H31C32.6568 20 34 21.3431 34 23C34 24.6569 32.6568 26 31 26H28.4853Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15C20 13.8954 20.8954 13 22 13C23.1046 13 24 13.8954 24 15C24 16.1046 23.1046 17 22 17C20.8954 17 20 16.1046 20 15ZM20 19.25C20 18.5596 20.5596 18 21.25 18C22.698 18 23.9543 18.8207 24.5792 20.0223C24.5038 20.0873 24.4304 20.1554 24.3591 20.2267L20 24.5858V19.25Z",
    fill: "#222222",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28C34.1311 28.0006 34.2609 28.0268 34.382 28.077C34.5647 28.1525 34.721 28.2805 34.831 28.4448C34.941 28.6091 34.9998 28.8023 35 29V33C35 33.2652 34.8947 33.5196 34.7071 33.7071C34.5196 33.8946 34.2652 34 34 34C33.7348 34 33.4804 33.8946 33.2929 33.7071C33.1054 33.5196 33 33.2652 33 33V31.414L29.707 34.707C29.6148 34.8025 29.5044 34.8787 29.3824 34.9311C29.2604 34.9835 29.1292 35.0111 28.9964 35.0123C28.8636 35.0134 28.732 34.9881 28.6091 34.9378C28.4862 34.8875 28.3745 34.8133 28.2806 34.7194C28.1867 34.6255 28.1125 34.5138 28.0622 34.391C28.0119 34.2681 27.9866 34.1364 27.9878 34.0036C27.9889 33.8708 28.0165 33.7396 28.0689 33.6176C28.1213 33.4956 28.1975 33.3852 28.293 33.293L31.586 30H30C29.7348 30 29.4804 29.8946 29.2929 29.7071C29.1054 29.5196 29 29.2652 29 29C29 28.7348 29.1054 28.4804 29.2929 28.2929C29.4804 28.1054 29.7348 28 30 28H34Z",
    fill: "#5BB52D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsLightUp4);
export default __webpack_public_path__ + "static/media/es-light-up-4.17e1de73a5c897223569d5e5d2f89ecd.svg";
export { ForwardRef as ReactComponent };